export const manifest = {
  screens: {
    scr_z11293: { name: "Inicio", route: "/", position: {"x":0,"y":0}, isDefaultRow: true },
    scr_8i8uer: { name: "Expedientes", route: "/expedientes", position: {"x":160,"y":1820} },
    scr_90jx4q: { name: "Nuevo expediente", route: "/expedientes/nuevo", position: {"x":1560,"y":1820} },
    scr_nrjrhh: { name: "Expediente · Etapas", route: "/expedientes/ex-01", state: {"pestana":"etapas"}, position: {"x":2960,"y":1820} },
    scr_ziypyr: { name: "Expediente · Documentos", route: "/expedientes/ex-01", state: {"pestana":"documentos"}, position: {"x":4360,"y":1820} },
    scr_p9npde: { name: "Expediente · Plazos", route: "/expedientes/ex-01", state: {"pestana":"plazos"}, position: {"x":5760,"y":1820} },
    scr_p7567w: { name: "Expediente · Audiencias", route: "/expedientes/ex-01", state: {"pestana":"audiencias"}, position: {"x":7160,"y":1820} },
    scr_ylvmz6: { name: "Expediente · Abogados", route: "/expedientes/ex-01", state: {"pestana":"abogados"}, position: {"x":8560,"y":1820} },
    scr_zlkomn: { name: "Expediente · Bitácora", route: "/expedientes/ex-01", state: {"pestana":"bitacora"}, position: {"x":9960,"y":1820} },
    scr_hhqog4: { name: "Calendario", route: "/calendario", position: {"x":160,"y":3800} },
    scr_2wjugd: { name: "Vencimientos", route: "/vencimientos", position: {"x":1560,"y":3800} },
    scr_d8m0m2: { name: "Almacenes", route: "/almacenes", position: {"x":1400,"y":0}, isDefaultRow: true },
    scr_nk7z69: { name: "Abogados y personal", route: "/abogados", position: {"x":160,"y":5780} },
    scr_em3t4z: { name: "Perfil de abogado", route: "/abogados/ab-01", position: {"x":1560,"y":5780} },
    scr_y5r2wy: { name: "Mi cuenta", route: "/mi-cuenta", position: {"x":2800,"y":0}, isDefaultRow: true },
    scr_xumuv6: { name: "Flujos de proceso", route: "/configuracion/flujos", position: {"x":160,"y":7760} },
    scr_lg9lt5: { name: "Catálogo de documentos", route: "/configuracion/documentos", position: {"x":1560,"y":7760} },
    scr_tznosc: { name: "Sucursales y almacenes", route: "/configuracion/sucursales", position: {"x":2960,"y":7760} },
    scr_be6qva: { name: "Detalle de sucursal", route: "/configuracion/sucursales/ver", position: {"x":4360,"y":7760} },
    scr_613va0: { name: "Integraciones", route: "/configuracion/integraciones", position: {"x":5760,"y":7760} },
  },
  sections: {
    sec_rwbtev: { name: "Expedientes", x: 0, y: 1600, width: 11320, height: 1180 },
    sec_murk9v: { name: "Calendario y vencimientos", x: 0, y: 3580, width: 2920, height: 1180 },
    sec_ey695w: { name: "Abogados y personal", x: 0, y: 5560, width: 2920, height: 1180 },
    sec_ll5dm3: { name: "Configuración", x: 0, y: 7540, width: 7120, height: 1180 },
  },
  layers: [
    { kind: "screen", id: "scr_z11293" },
    { kind: "screen", id: "scr_d8m0m2" },
    { kind: "screen", id: "scr_y5r2wy" },
    { kind: "section", id: "sec_rwbtev", children: [
      { kind: "screen", id: "scr_8i8uer" },
      { kind: "screen", id: "scr_90jx4q" },
      { kind: "screen", id: "scr_nrjrhh" },
      { kind: "screen", id: "scr_ziypyr" },
      { kind: "screen", id: "scr_p9npde" },
      { kind: "screen", id: "scr_p7567w" },
      { kind: "screen", id: "scr_ylvmz6" },
      { kind: "screen", id: "scr_zlkomn" },
    ] },
    { kind: "section", id: "sec_murk9v", children: [
      { kind: "screen", id: "scr_hhqog4" },
      { kind: "screen", id: "scr_2wjugd" },
    ] },
    { kind: "section", id: "sec_ey695w", children: [
      { kind: "screen", id: "scr_nk7z69" },
      { kind: "screen", id: "scr_em3t4z" },
    ] },
    { kind: "section", id: "sec_ll5dm3", children: [
      { kind: "screen", id: "scr_xumuv6" },
      { kind: "screen", id: "scr_lg9lt5" },
      { kind: "screen", id: "scr_tznosc" },
      { kind: "screen", id: "scr_be6qva" },
      { kind: "screen", id: "scr_613va0" },
    ] },
  ],
}
